import i18next from 'i18next';
import languageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

const defaultLanguage = 'en';
const storedLanguage = localStorage.getItem('i18nextLng');
const language = storedLanguage || defaultLanguage;

i18next
  .use(languageDetector)
  .use(initReactI18next)
  .init({
    debug: true,
    lng: language, // Default language
    fallbackLng: 'en', // Fallback language if translation is missing
    resources: {
      en: {
        translation: {
          common: require('@/locales/en/common.json'),
          validation: require('@/locales/en/validation.json'),
          home: require('@/locales/en/home.json'),
          navbar: require('@/locales/en/navbar.json'),
        },
      },
      es: {
        translation: {
          common: require('@/locales/es/common.json'),
          validation: require('@/locales/es/validation.json'),
          home: require('@/locales/es/home.json'),
          navbar: require('@/locales/es/navbar.json'),
        },
      },
    },
  });
